import { Navigate } from "react-router";
import { useUpdateTransactionsMutation } from "../../stores/OkOkStore";
import type { Transactions } from "../../types/Transaction";
import { useForm } from "react-hook-form";
import { FloatinBooleanBootstrap } from "../Common/FloatingInputBootstrap";
import { useTrads } from "../../contexts/trads/useTrads";

function TransactionEdit({transactionParam}:{transactionParam:Transactions}){
    const [updateTransaction, result] = useUpdateTransactionsMutation();

    const { register, handleSubmit, formState: { errors }  } = useForm({
        defaultValues:transactionParam,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();

    const onSubmit=function(transaction:Partial<Transactions> & Pick<Transactions,'id'>){
        return updateTransaction(transaction);
    }
    return (
        result.isSuccess ? <span><Navigate to={`/transactions/`} state={{modified:"true",data_id:transactionParam.id}}></Navigate></span> :(
        result.error && 'status' in result.error && result.error.status!=400 ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>:
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <>
            <form className="row" onSubmit={(event) => void handleSubmit(onSubmit)(event)}>
                <FloatinBooleanBootstrap 
                    name='regle'
                    label={translate('transaction_regle')}
                    registerOutput={register('regle',{})}
                    errors={errors}
                    
                />

                <div className="col-12  mb-3">
                    <button type="submit">{translate('form_submit')}</button>
                </div>

            </form>
        </>
    )
    );
}
export default TransactionEdit;